export const TOGGLE_DASHBOARD_TABLE = 'TOGGLE_DASHBOARD_TABLE'

export const GET_DASHBOARD_CAMPAIGN_RULES = 'GET_DASHBOARD_CAMPAIGN_RULES'
